import { Col } from 'antd';
import React from 'react';
import { cleanString, createMarkup } from '../../util/renderHelpers';

type ErrorPageProps = {
  children?: never;
  errorContent: string;
};

const ErrorPage: React.FC<ErrorPageProps> = ({ errorContent }) => {
  return (
    <Col
      className="error__content"
      dangerouslySetInnerHTML={createMarkup(cleanString(errorContent))}
    />
  );
};

export default ErrorPage;
